<template>
  <svg
    width="228"
    height="362"
    viewBox="0 0 228 362"
    xmlns="http://www.w3.org/2000/svg"
    :fill="fill"
  >
    <path
      d="M171.824 0C191.378 0 201.155 0.000314624 208.623 3.80566C215.193 7.15297 220.534 12.494 223.881 19.0635C227.686 26.5319 227.687 36.3088 227.687 55.8623V349.138C227.687 368.691 227.686 378.468 223.881 385.937C220.534 392.506 215.193 397.847 208.623 401.194C201.155 405 191.378 405 171.824 405H55.8623C36.3088 405 26.5319 405 19.0635 401.194C12.494 397.847 7.15297 392.506 3.80566 385.937C0.000308961 378.468 0 368.691 0 349.138V55.8623C0 36.3088 0.000308961 26.5319 3.80566 19.0635C7.15297 12.494 12.494 7.15297 19.0635 3.80566C26.5319 0.000329522 36.3088 0 55.8623 0H59.4414V5.95703C59.4415 10.4562 63.0887 14.1035 67.5879 14.1035H159.094C163.593 14.1033 167.24 10.4561 167.24 5.95703V0H171.824Z"
      :fill="fill"
    />
  </svg>
</template>

<script>
export default {
  name: 'PhoneScreenSolidMock',
  props: {
    fill: {
      type: String,
      require: true,
    },
  },
};
</script>
